"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GreenlineEventTypes = void 0;
const enums_1 = require("./enums");
const WpTransactionEventTypes = {
    CREATED: enums_1.EventTypes.CREATED,
    FAILED: enums_1.EventTypes.FAILED,
};
const WpConfigEventTypes = {
    DELETED: enums_1.EventTypes.DELETED,
};
const PaymentEventTypes = Object.assign({}, enums_1.EventTypes);
const ProductEventTypes = Object.assign({}, enums_1.EventTypes);
const InventoryEventTypes = {
    UPDATED: enums_1.EventTypes.UPDATED,
};
const PaymentQueueEventTypes = Object.assign({}, enums_1.EventTypes);
const CustomerEventTypes = Object.assign({}, enums_1.EventTypes);
const EmployeeEventTypes = Object.assign({}, enums_1.EventTypes);
const WebhookEventTypes = {
    CREATED: enums_1.EventTypes.CREATED,
};
const CategoryEventTypes = Object.assign({}, enums_1.EventTypes);
const DiscountEventTypes = Object.assign({}, enums_1.EventTypes);
const ExternalSourceEventTypes = {
    UPDATED: enums_1.EventTypes.UPDATED,
};
exports.GreenlineEventTypes = {
    WP_CONFIG: WpConfigEventTypes,
    WP_TRANSACTION: WpTransactionEventTypes,
    PAYMENT: PaymentEventTypes,
    PRODUCT: ProductEventTypes,
    PAYMENT_QUEUE: PaymentQueueEventTypes,
    INVENTORY: InventoryEventTypes,
    CUSTOMER: CustomerEventTypes,
    EMPLOYEE: EmployeeEventTypes,
    WEBHOOK: WebhookEventTypes,
    DISCOUNT: DiscountEventTypes,
    CATEGORY: CategoryEventTypes,
    EXTERNAL_SOURCE: ExternalSourceEventTypes,
};
//# sourceMappingURL=constants.js.map